import React from "react";
import { connect } from "react-redux";
import ImageContainer from "@components/imageContainer";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import DiamondShapeIcon from "@public/images/dashcam/DiamondShape.svg";
import {
  DashcamContainer,
  BackgroundWrapper,
  ContentContainer,
  IntroducingContainer,
  IntroducingText,
  MainHeading,
  LogoContainer,
//   VideoBackground,
  ContentWrapper
} from "./styles";
import CloneChildren from "@components/children";

export interface IDashcam extends CommonProps {
  introducingText?: string;
  mainHeading?: string;
  backgroundImage?: string;
  logoImage?: string;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const Dashcam = (props: IDashcam) => {
  const { 
    is_visible, 
    introducingText, 
    mainHeading,
    backgroundImage,
    logoImage,
    styles,
    children,
    id 
  } = props;

  return (id && is_visible) || !id ? (
    <DashcamContainer styles={styles}>
      <BackgroundWrapper backgroundImage={backgroundImage || ""} />
      <ContentContainer>
        <ContentWrapper>
          <IntroducingContainer>
            <DiamondShapeIcon />
            <IntroducingText>{introducingText}</IntroducingText>
            <DiamondShapeIcon />
          </IntroducingContainer>
          <MainHeading>{mainHeading}</MainHeading>
          <LogoContainer>
            {/* <VideoBackground
              autoPlay
              loop
              muted
              playsInline
            >
              <source src="/images/dashcam/DashcamVideo.mp4" type="video/mp4" />
            </VideoBackground> */}
            <ImageContainer
              imgSrc={logoImage}
              height={200}
              width={200}
              alt="Dashcam Logo"
              styles={{
                objectFit: "contain",
                position: "relative",
                zIndex: 2,
                mixBlendMode: "multiply"
              }}
            />
          </LogoContainer>
        </ContentWrapper>
      </ContentContainer>
      {children && <CloneChildren>{children}</CloneChildren>}
    </DashcamContainer>
  ) : null;
};

export default connect(mapStateToProps)(Dashcam);
